import { Component } from '@angular/core';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';

@Component({
  selector: 'app-optional-complete-activity-view',
  templateUrl: './optional-complete-activity-view.component.html',
  styleUrl: './optional-complete-activity-view.component.css',
  standalone: false
})
export class OptionalCompleteActivityViewComponent extends ActivityView {}
